import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import card1 from '../assets/images/account-offer-recived/card1.png';
import card2 from '../assets/images/account-offer-recived/card2.png';
import buyerIcon from '../assets/images/user-profile/profile-picture.png';
import Header from './Header';
import Footer from './Footer';

class AccountActivityOfferReceived extends Component {
    OfferRecItemDetails = () => {
        this.props.history.push('/OfferRecItemDetails');
    }
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* MArketplace area start */}
                <div className="buyer-activity-heading">
                    <h1>Account Activity</h1>
                    <h1>CURATED</h1>
                    <div className="container-fluid buyer-activity">
                        <div className="row head justify-content-between">
                            <h4></h4>
                            <h4>Sort By <i className="fa fa-arrow-up"></i><i className="fa fa-arrow-down"></i></h4>
                        </div>
                        <div className="container-fluid buyer-activity-detail mb-5 h-100">
                            <div className="row h-100">
                                <aside className="col-12 col-md-2 p-0">
                                    <nav className="navbar navbar-expand flex-md-column flex-row align-items-start">
                                        <div className="collapse navbar-collapse">
                                            <ul>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityBuyer">Purchases</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivitySales">Sales</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0 active" to="/AccountActivityOfferReceived">Offers Received</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityOfferMade">Offers Made</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityBid">BIDS</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </aside>
                                <main className="col">
                                    <nav className="marketplace-card">
                                        <div className="most-popular row">
                                            <div className="card">
                                                <Link to="/OfferRecItemDetails">
                                                    <img src={card1} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/OfferRecItemDetails">
                                                        <h3>Yellow and green bird #22</h3>
                                                    </Link>
                                                    <h5><img src={buyerIcon} alt="buyer" className="buyerIcon" /><span>OFFERED YOU</span>&emsp;$13,000</h5>
                                                    <button onClick={this.OfferRecItemDetails}>View Details</button>
                                                    <p className="card-text"><span>OFFER EXPIRES&emsp;<strong>2d</strong></span></p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/OfferRecItemDetails">
                                                    <img src={card2} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/OfferRecItemDetails">
                                                        <h3>Artwork Title #11</h3>
                                                    </Link>
                                                    <h5><img src={buyerIcon} alt="buyer" className="buyerIcon" /><span>OFFERED YOU</span>&emsp;$10,000</h5>
                                                    <button onClick={this.OfferRecItemDetails}>View Details</button>
                                                    <p className="card-text"><span>OFFER EXPIRES&emsp;<strong>1d 2h</strong></span></p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/OfferRecItemDetails">
                                                    <img src={card2} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/OfferRecItemDetails">
                                                        <h3>Artwork Title #12</h3>
                                                    </Link>
                                                    <h5><img src={buyerIcon} alt="buyer" className="buyerIcon" /><span>OFFERED YOU</span>&emsp;$10,000</h5>
                                                    <button onClick={this.OfferRecItemDetails}>View Details</button>
                                                    <p className="card-text"><span>OFFER EXPIRES&emsp;<strong>6h 5m</strong></span></p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/OfferRecItemDetails">
                                                    <img src={card2} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/OfferRecItemDetails">
                                                        <h3>Artwork Title #12</h3>
                                                    </Link>
                                                    <h5><img src={buyerIcon} alt="buyer" className="buyerIcon" /><span>OFFERED YOU</span>&emsp;$10,000</h5>
                                                    <button onClick={this.OfferRecItemDetails}>View Details</button>
                                                    <p className="card-text"><span>OFFER EXPIRES&emsp;<strong>2m 20s</strong></span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </main>
                            </div>
                        </div>
                    </div>
                    {/* Footer area start */}
                    <Footer></Footer>
                    {/* Footer area end */}
                </div>
                {/* MArketplace area end */}
            </div>
        )
    }
};

export default AccountActivityOfferReceived;